module.exports = {"clubLogo":"골프클럽 BI"}


//////////////////
// WEBPACK FOOTER
// ./src/locales/ko/footer.json
// module id = 6VHn
// module chunks = 2